import { Form, FormInstance, Input } from "antd";
import { ChartFormFieldsEnum } from "../../enum";
import { UserOverviewMemo } from "./user-overview";
import React from "react";
import { MetricPerformance } from "./metric-performance";
import { FunnelExploration } from "./funnel-exploration";
import { RetentionExploration } from "./retention-exploration";

const ShowChartResult: React.FC<{ form: FormInstance }> = ({ form }) => {
    return (
        <>
            <UserOverviewMemo form={form} />
            <FunnelExploration form={form} />
            <RetentionExploration form={form} />

            <div className="mt-4" />
            <MetricPerformance form={form} />

            <Form.Item name={ChartFormFieldsEnum.FILTER_FIELDS} hidden>
                <Input />
            </Form.Item>
        </>
    );
};
export const ShowChartResultMemo = React.memo(ShowChartResult);
